import { request } from "../util/Request";

export async function getRoleList() {
  const response = await request(`/api/Role/Get`);
  return await response.json();
}
